import { render, staticRenderFns } from "./promosAnswerTable.vue?vue&type=template&id=0db15282"
import script from "./promosAnswerTable.vue?vue&type=script&lang=js"
export * from "./promosAnswerTable.vue?vue&type=script&lang=js"
import style0 from "./promosAnswerTable.vue?vue&type=style&index=0&id=0db15282&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports